// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * An OPC UA StatusCode carried as a value.
 */
export class StatusCodeValue implements flatbuffers.IUnpackableObject<StatusCodeValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): StatusCodeValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsStatusCodeValue(
    bb: flatbuffers.ByteBuffer,
    obj?: StatusCodeValue,
  ): StatusCodeValue {
    return (obj || new StatusCodeValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsStatusCodeValue(
    bb: flatbuffers.ByteBuffer,
    obj?: StatusCodeValue,
  ): StatusCodeValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new StatusCodeValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startStatusCodeValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt32(0, value, 0);
  }

  static endStatusCodeValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createStatusCodeValue(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    StatusCodeValue.startStatusCodeValue(builder);
    StatusCodeValue.addValue(builder, value);
    return StatusCodeValue.endStatusCodeValue(builder);
  }

  unpack(): StatusCodeValueT {
    return new StatusCodeValueT(this.value());
  }

  unpackTo(_o: StatusCodeValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): StatusCodeValueT {
    const t = new StatusCodeValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class StatusCodeValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return StatusCodeValue.createStatusCodeValue(builder, this.value);
  }

  clone(): StatusCodeValueT {
    const obj = new StatusCodeValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: StatusCodeValueT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyStatusCodeValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
  } finally {
    verifier.popDepth();
  }
}
